/**
 * 分页修复专用 mixin（Vue2 + ElementUI 专用）
 * 作用：解决页面缓存 + 切换标签页后，分页器页码不刷新、显示错乱的问题
 */
export default {
  watch: {
    // 监听分页参数 params.current 的变化
    // 只要页码发生改变，就自动同步到分页器组件内部
    'params.current': {
      // immediate: true = 页面一加载就立即执行一次
      // 解决页面刷新/返回时，分页器不初始化的问题
      immediate: true,

      handler() {
        // this.$nextTick 等待 DOM 渲染完成
        // 必须加，否则获取不到分页器组件
        this.$nextTick(() => {
          // 获取页面上 ref="pagination" 的分页器组件
          const pagination = this.$refs.pagination

          // 安全判断：
          // 1. 分页器必须存在
          // 2. params 必须存在
          // 3. 当前页码 current 必须有值
          if (pagination && this.params && this.params.current) {

            // 强制修改 ElementUI 分页器内部的当前页码
            // 这是修复 ElementUI 缓存不刷新的核心 hack
            pagination.internalCurrentPage = this.params.current

            // 强制让分页器重新渲染视图
            // 让页面显示正确的页码
            pagination.$forceUpdate()
          }
        })
      }
    }
  }
}
